<template>
  <v-container fluid>
    <v-card flat>
      <v-card-title class="mb-3 text-h5 font-weight-bold">
        {{ wordList.lbl_delivery_setting }}
      </v-card-title>
    </v-card>
    <v-tabs v-model="model" hide-slider>
      <div class="tab_switch d-flex align-center">
        <v-tab
          :class="[model === 0 ? 'tab_switch_active' : 'tab_switch_inactive', 'd-flex align-center justify-center rounded-pill']"
          @click="onClickTimeTab"
        >
          {{ wordList.lbl_delivery_time_list }}
        </v-tab>
        <v-tab
          :class="[model === 1 ? 'tab_switch_active' : 'tab_switch_inactive', 'ml-2 d-flex align-center justify-center rounded-pill']"
          @click="onClickGroupTab"
        >
          {{ wordList.lbl_delivery_cap_list }}
        </v-tab>
      </div>
    </v-tabs>
    <!-- 配達時間設定タブ { -->
    <v-tabs-window v-model="model">
      <v-tabs-window-item :value="0">
          <v-card
            v-if="
              !displayInputDialog &&
              !displayConfirmDialog &&
              !displayCompletedDialog
            "
            flat
          >
            <form>
              <v-card flat class="mt-5">
                <v-expansion-panels v-model="panel" flat multiple class="br_1">
                  <v-expansion-panel>
                    <v-expansion-panel-title class="d-none"></v-expansion-panel-title>
                    <v-expansion-panel-text class="bk_gray_3">
                      <v-card-text>
                        <v-row class="pt-4">
                          <!-- チェーン名 -->
                          <v-col v-if="chainViewFlag" sm="6" md="4" class="py-0">
                            <v-autocomplete
                              v-model="chainSelectValues"
                              density="compact"
                              :items="chainListItems"
                              item-title="name"
                              item-value="chain_code"
                              :label="wordList.lbl_chain_name"
                              :placeholder="wordList.plc_selectbox"
                              :no-data-text="wordList.lbl_no_data_text"
                              bg-color="white"
                              return-object
                              variant="outlined"
                              @update:model-value="onChangeChain"
                            ></v-autocomplete>
                          </v-col>
                          <!-- 店舗名 -->
                          <v-col sm="6" md="4" class="py-0">
                            <v-autocomplete
                              v-model="shopSelectValues"
                              density="compact"
                              :items="shopListItems"
                              item-title="name"
                              item-value="shop_code"
                              :label="wordList.lbl_shop_name"
                              :placeholder="wordList.plc_selectbox"
                              :no-data-text="wordList.lbl_no_data_text"
                              bg-color="white"
                              return-object
                              variant="outlined"
                              @update:model-value="onChangeShop"
                            ></v-autocomplete>
                          </v-col>
                          <!-- エリア名 -->
                          <v-col sm="6" md="4" class="py-0">
                            <v-autocomplete
                              v-model="areaSelectValues"
                              density="compact"
                              :items="areaListItems"
                              item-title="area_name"
                              item-value="area_code"
                              :label="wordList.lbl_area_name"
                              :placeholder="wordList.plc_selectbox"
                              :no-data-text="wordList.lbl_no_data_text"
                              :disabled="
                                shopSelectValues === null ||
                                shopSelectValues.name.length == 0
                              "
                              bg-color="white"
                              return-object
                              variant="outlined"
                              @update:model-value="onChangeArea"
                            ></v-autocomplete>
                          </v-col>
                        </v-row>
                      </v-card-text>
                      <v-col class="text-red">
                        {{ wordList.lbl_shop_select }}
                      </v-col>
                    </v-expansion-panel-text>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-card>
            </form>
            <v-row class="justify-end mt-5" style="width: 100%; overflow: visible;" no-gutters>
              <v-btn
                color="primary"
                class="mb-2 px-10 py-2"
                :disabled="
                  shopSelectValues === null ||
                  shopSelectValues.name.length == 0 ||
                  areaListItems === null ||
                  areaListItems === undefined ||
                  areaListItems.length == 0
                "
                @click="onClickNewRegister"
              >
                {{ wordList.lbl_new_add }}
              </v-btn>
            </v-row>
            <div
              v-for="[key, value] in Array.from(mappedListData)"
              :key="key"
              :value="value"
            >
              <span v-if="selectShopFlg" class="catch_area pt-5">{{
                getAreaName(key)
              }}</span>
              <v-data-table
                v-if="selectShopFlg"
                :items="value"
                :headers="tableHeaders"
                :items-per-page="value.length"
                :no-data-text="wordList.lbl_no_data_text"
                hide-default-footer
              >
                <template #[`item.actions`]="{ item }">
                  <div>
                    <v-btn
                      variant="outlined"
                      color="primary"
                      class="my-2 ml-2"
                      size="x-small"
                      icon
                      @click="onClickEdit(item)"
                    >
                      <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                    <v-btn
                      variant="outlined"
                      color="red"
                      class="my-2 ml-2"
                      size="x-small"
                      icon
                      @click="onClickDelete(item)"
                    >
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </div>
                </template>
              </v-data-table>
            </div>
            <span v-if="selectAreaFlg" class="catch_area pt-5">{{
              getAreaName(areaSelectValues.area_code)
            }}</span>
            <v-data-table
              v-if="selectAreaFlg"
              :items="listDataArray"
              :headers="tableHeaders"
              :items-per-page="listDataArray.length"
              :no-data-text="wordList.lbl_no_data_text"
              hide-default-footer
            >
              <template #[`item.actions`]="{ item }">
                <div>
                  <v-btn
                    variant="outlined"
                    color="primary"
                    class="my-2 ml-2 rounded-full"
                    size="x-small"
                    icon
                    @click="onClickEdit(item)"
                  >
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                  <v-btn
                    variant="outlined"
                    color="red"
                    class="my-2 ml-2 rounded-full"
                    size="x-small"
                    icon
                    @click="onClickDelete(item)"
                  >
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </div>
              </template>
            </v-data-table>
          </v-card>
          <!-- 配達時間登録ダイアログ { -->
          <v-card v-if="displayInputDialog && mode === 'time'" class="mt-10">
            <Form v-slot="{ validate }" ref="timeFormRef">
              <v-card>
                <v-card-title class="mt-3 pb-5 text-h5 font-weight-bold">
                  {{ wordList.lbl_delivery_time_regist }}
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <!-- チェーン名 -->
                    <v-row>
                      <v-col cols="4" class="font-weight-black">
                        <v-row align="center" dense class="form-label-row mr-3" justify="end">
                          {{ wordList.lbl_chain_name }}
                          <ImportantChip></ImportantChip>
                        </v-row>
                      </v-col>
                      <v-col cols="4">{{
                        getChainName(chainSelectValues.chain_code)
                      }}</v-col>
                    </v-row>
                    <!-- 店舗名 -->
                    <v-row>
                      <v-col cols="4" class="font-weight-black">
                        <v-row align="center" dense class="form-label-row mr-3" justify="end">
                          {{ wordList.lbl_shop_name }}
                          <ImportantChip></ImportantChip>
                        </v-row>
                      </v-col>
                      <v-col cols="4">{{
                        getShopName(shopSelectValues.shop_code)
                      }}</v-col>
                    </v-row>
                    <!-- エリア名称 -->
                    <v-row>
                      <v-col cols="4" class="font-weight-black">
                        <v-row align="center" dense class="form-label-row mr-3" justify="end">
                          {{ wordList.lbl_area_name }}
                          <ImportantChip></ImportantChip>
                        </v-row>
                      </v-col>
                      <v-col v-if="processFlag == 0" cols="4">
                        <Field
                          v-slot="{ errors, field }"
                          :name="fieldName('lbl_area_name')"
                          rules="required"
                        >
                          <v-autocomplete
                            v-model="areaEditSelectValues"
                            density="compact"
                            :items="newAreaListItems"
                            item-title="area_name"
                            item-value="area_code"
                            :label="wordList.lbl_area_name"
                            :error-messages="errors"
                            :placeholder="wordList.plc_selectbox"
                            :no-data-text="wordList.lbl_no_data_text"
                            :disabled="shopSelectValues === null"
                            return-object
                            variant="outlined"
                            @update:model-value="field.onChange"
                            @blur="field.onBlur"
                          ></v-autocomplete>
                        </Field>
                      </v-col>
                      <v-col v-if="processFlag > 0" cols="6" class="mb-8">
                        {{ getAreaName(deliveryTimeCommonInput.area_code) }}
                      </v-col>
                    </v-row>
                    <!-- 配達便 -->
                    <v-row>
                      <v-col cols="4" class="font-weight-black">
                        <v-row align="center" dense class="form-label-row mr-3" justify="end">
                          {{ wordList.lbl_delivery_id }}
                          <ImportantChip></ImportantChip>
                        </v-row>
                      </v-col>
                      <v-col v-if="processFlag == 0" cols="4">
                        <Field
                          v-slot="{ errors, field }"
                          :name="fieldName('lbl_delivery_id')"
                          rules="required"
                        >
                          <v-autocomplete
                            v-model="deliverySelectValues"
                            density="compact"
                            :items="deliveryItems"
                            item-title="label"
                            item-value="delivery_id"
                            :label="wordList.lbl_delivery_id"
                            :error-messages="errors"
                            :no-data-text="wordList.lbl_no_data_text"
                            bg-color="white"
                            return-object
                            variant="outlined"
                            @update:model-value="field.onChange"
                            @blur="(event) => { field.onBlur(event); onBlurDeliveryId(); }"
                          ></v-autocomplete>
                        </Field>
                      </v-col>
                      <v-col v-if="processFlag > 0" cols="6" class="mb-8">
                        {{ deliverySelectValues.label }}
                      </v-col>
                    </v-row>
                    <!-- 開始時間 -->
                    <v-row>
                      <v-col cols="4" class="font-weight-black">
                        <v-row align="center" dense class="form-label-row mr-3" justify="end">
                          {{ wordList.lbl_delivery_start_time }}
                          <ImportantChip></ImportantChip>
                        </v-row>
                      </v-col>
                      <v-col cols="4">
                        <Field
                          v-slot="{ errors, field }"
                          :name="fieldName('lbl_delivery_start_time')"
                          rules="required|time_format"
                        >
                          <v-text-field
                            v-model="
                              deliveryTimeCommonInput.delivery_start_time
                            "
                            density="compact"
                            variant="outlined"
                            :placeholder="wordList.plc_delivery_start_time"
                            :error-messages="errors"
                            @update:model-value="field.onChange"
                            @blur="field.onBlur"
                            @change="onChangeDeliveryStartTime"
                          ></v-text-field>
                        </Field>
                      </v-col>
                    </v-row>
                    <!-- 終了時間 -->
                    <v-row>
                      <v-col cols="4" class="font-weight-black">
                        <v-row align="center" dense class="form-label-row mr-3" justify="end">
                          {{ wordList.lbl_delivery_end_time }}
                          <ImportantChip></ImportantChip>
                        </v-row>
                      </v-col>
                      <v-col cols="4">
                        <Field
                          v-slot="{ errors, field }"
                          :name="fieldName('lbl_delivery_end_time')"
                          rules="required|time_format"
                        >
                          <v-text-field
                            v-model="deliveryTimeCommonInput.delivery_end_time"
                            density="compact"
                            variant="outlined"
                            :placeholder="wordList.plc_delivery_end_time"
                            :error-messages="errors"
                            @update:model-value="field.onChange"
                            @blur="field.onBlur"
                            @change="onChangeDeliveryEndTime"
                          ></v-text-field>
                        </Field>
                      </v-col>
                    </v-row>
                    <!-- キャップ数設定 -->
                    <v-row>
                      <v-col cols="4" class="font-weight-black">
                        <v-row align="center" dense class="form-label-row mr-3" justify="end">
                          {{ wordList.lbl_delivery_cap_setting }}
                          <ImportantChip></ImportantChip>
                        </v-row>
                      </v-col>
                      <v-col cols="6">
                        <Field
                          v-slot="{ errors, field }"
                          :name="fieldName('lbl_delivery_cap_setting')"
                          rules="required"
                        >
                          <v-radio-group
                            :model-value="selectTimeCapSelectValues.index"
                            inline
                            mandatory
                            :error-messages="errors"
                            class="mt-0"
                            @update:model-value="(value) => { selectTimeCapSelectValues.index = value; field.onChange(value); onChangeCapSelect(); }"
                            @blur="field.onBlur"
                          >
                            <v-radio
                              v-for="item in selectTimeCapItems"
                              :key="item.index"
                              :label="item.item"
                              :value="item.index"
                              color="indigo"
                              density="compact"
                            ></v-radio>
                          </v-radio-group>
                        </Field>
                      </v-col>
                    </v-row>
                    <!-- 全曜日 -->
                    <v-row v-if="selectTimeCapSelectValues.index == 0">
                      <v-col cols="4" class="font-weight-black">
                        <v-row align="center" dense class="form-label-row mr-3" justify="end">
                          {{ wordList.lbl_max_deliverable_unit }}
                          <ImportantChip></ImportantChip>
                        </v-row>
                      </v-col>
                      <v-col cols="1" class="px-1">
                        <Field
                          v-slot="{ errors, field }"
                          :name="fieldName('lbl_max_deliverable_unit')"
                          rules="required|numeric|max:3"
                        >
                          <v-text-field
                            v-model="
                              deliveryTimeCommonInput.max_deliverable_unit
                            "
                            density="compact"
                            variant="outlined"
                            :error-messages="errors"
                            style="min-width: 80px;"
                            @update:model-value="field.onChange"
                            @blur="field.onBlur"
                          ></v-text-field>
                        </Field>
                      </v-col>
                    </v-row>
                    <!-- 曜日ごと -->
                    <v-row v-if="selectTimeCapSelectValues.index == 1">
                      <v-col cols="4" class="font-weight-black">
                        <v-row align="center" dense class="form-label-row mr-3" justify="end">
                          {{ wordList.lbl_delivery_day_cap }}
                          <ImportantChip></ImportantChip>
                        </v-row>
                      </v-col>
                      <!-- 月曜日 -->
                      <v-col cols="1" class="px-1">
                        <Field
                          v-slot="{ errors, field }"
                          :name="fieldName('lbl_delivery_cap_mon')"
                          rules="required|numeric|max:3"
                        >
                          <v-text-field
                            v-model="deliveryTimeCommonInput.delivery_cap_mon"
                            density="compact"
                            :label="wordList.lbl_delivery_cap_mon"
                            variant="outlined"
                            :error-messages="errors"
                            @update:model-value="field.onChange"
                            @blur="field.onBlur"
                          ></v-text-field>
                        </Field>
                      </v-col>
                      <!-- 火曜日 -->
                      <v-col cols="1" class="px-1">
                        <Field
                          v-slot="{ errors, field }"
                          :name="fieldName('lbl_delivery_cap_tue')"
                          rules="required|numeric|max:3"
                        >
                          <v-text-field
                            v-model="deliveryTimeCommonInput.delivery_cap_tue"
                            density="compact"
                            :label="wordList.lbl_delivery_cap_tue"
                            variant="outlined"
                            :error-messages="errors"
                            @update:model-value="field.onChange"
                            @blur="field.onBlur"
                          ></v-text-field>
                        </Field>
                      </v-col>
                      <!-- 水曜日 -->
                      <v-col cols="1" class="px-1">
                        <Field
                          v-slot="{ errors, field }"
                          :name="fieldName('lbl_delivery_cap_wed')"
                          rules="required|numeric|max:3"
                        >
                          <v-text-field
                            v-model="deliveryTimeCommonInput.delivery_cap_wed"
                            density="compact"
                            :label="wordList.lbl_delivery_cap_wed"
                            variant="outlined"
                            :error-messages="errors"
                            @update:model-value="field.onChange"
                            @blur="field.onBlur"
                          ></v-text-field>
                        </Field>
                      </v-col>
                      <!-- 木曜日 -->
                      <v-col cols="1" class="px-1">
                        <Field
                          v-slot="{ errors, field }"
                          :name="fieldName('lbl_delivery_cap_thu')"
                          rules="required|numeric|max:3"
                        >
                          <v-text-field
                            v-model="deliveryTimeCommonInput.delivery_cap_thu"
                            density="compact"
                            :label="wordList.lbl_delivery_cap_thu"
                            variant="outlined"
                            :error-messages="errors"
                            @update:model-value="field.onChange"
                            @blur="field.onBlur"
                          ></v-text-field>
                        </Field>
                      </v-col>
                      <!-- 金曜日 -->
                      <v-col cols="1" class="px-1">
                        <Field
                          v-slot="{ errors, field }"
                          :name="fieldName('lbl_delivery_cap_fri')"
                          rules="required|numeric|max:3"
                        >
                          <v-text-field
                            v-model="deliveryTimeCommonInput.delivery_cap_fri"
                            density="compact"
                            :label="wordList.lbl_delivery_cap_fri"
                            variant="outlined"
                            :error-messages="errors"
                            @update:model-value="field.onChange"
                            @blur="field.onBlur"
                          ></v-text-field>
                        </Field>
                      </v-col>
                      <!-- 土曜日 -->
                      <v-col cols="1" class="px-1">
                        <Field
                          v-slot="{ errors, field }"
                          :name="fieldName('lbl_delivery_cap_sat')"
                          rules="required|numeric|max:3"
                        >
                          <v-text-field
                            v-model="deliveryTimeCommonInput.delivery_cap_sat"
                            density="compact"
                            :label="wordList.lbl_delivery_cap_sat"
                            variant="outlined"
                            :error-messages="errors"
                            @update:model-value="field.onChange"
                            @blur="field.onBlur"
                          ></v-text-field>
                        </Field>
                      </v-col>
                      <!-- 日曜日 -->
                      <v-col cols="1" class="px-1">
                        <Field
                          v-slot="{ errors, field }"
                          :name="fieldName('lbl_delivery_cap_sun')"
                          rules="required|numeric|max:3"
                        >
                          <v-text-field
                            v-model="deliveryTimeCommonInput.delivery_cap_sun"
                            density="compact"
                            :label="wordList.lbl_delivery_cap_sun"
                            variant="outlined"
                            :error-messages="errors"
                            @update:model-value="field.onChange"
                            @blur="field.onBlur"
                          ></v-text-field>
                        </Field>
                      </v-col>
                    </v-row>
                    <!-- 表示設定 -->
                    <v-row>
                      <v-col cols="4" class="font-weight-black">
                        <v-row align="center" dense class="form-label-row mr-3" justify="end">
                          {{ wordList.lbl_display_setting }}
                          <ImportantChip></ImportantChip>
                        </v-row>
                      </v-col>
                      <v-col cols="4">
                        <Field
                          v-slot="{ errors, field }"
                          :name="fieldName('lbl_display_setting')"
                        >
                          <v-autocomplete
                            v-model="displayDaysSettingValues"
                            density="compact"
                            :items="displayDaysSettingItem"
                            item-title="label"
                            item-value="display_days_setting"
                            :label="wordList.lbl_display_setting"
                            :error-messages="errors"
                            :no-data-text="wordList.lbl_no_data_text"
                            bg-color="white"
                            return-object
                            variant="outlined"
                            @update:model-value="field.onChange"
                            @blur="field.onBlur"
                          ></v-autocomplete>
                        </Field>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-card-actions class="justify-center py-10">
                  <!-- 戻るボタン -->
                  <v-btn
                    variant="flat"
                    color="return"
                    class="px-16"
                    @click="onClickInputCancel"
                  >
                    <v-icon>mdi-arrow-left</v-icon>
                    {{ wordList.btn_return }}</v-btn
                  >
                  <!-- 確認画面へボタン -->
                  <v-btn
                    variant="flat"
                    color="primary"
                    class="px-16"
                    :disabled="!isTimeFormValid"
                    @click="onClickOpenConfirmDialog(validate)"
                  >
                    <v-icon>mdi-playlist-edit</v-icon>
                    {{ wordList.btn_regist_confirm }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </Form>
          </v-card>
          <!-- } 配達時間登録ダイアログ -->
          <!-- 配達時間登録確認ダイアログ { -->
          <v-card v-if="displayConfirmDialog" class="mt-10">
            <v-card>
              <v-card-title class="mt-3 pb-5 text-h5 font-weight-bold">
                {{ wordList.lbl_delivery_time_regist_confirm }}
              </v-card-title>
              <v-card-text style="" class="pt-5 confirm-display-text">
                <!-- チェーン名 -->
                <v-row class="mb-2">
                  <v-col cols="4" class="font-weight-black">
                    <v-row align="center" dense class="py-2 pl-2" justify="end">
                      {{ wordList.lbl_chain_name }}
                      <ImportantChip></ImportantChip>
                    </v-row>
                  </v-col>
                  <v-col>{{
                    getChainName(chainSelectValues.chain_code)
                  }}</v-col>
                </v-row>
                <!-- 店舗名 -->
                <v-row class="mb-2">
                  <v-col cols="4" class="font-weight-black">
                    <v-row align="center" dense class="py-2 pl-2" justify="end">
                      {{ wordList.lbl_shop_name }}
                      <ImportantChip></ImportantChip>
                    </v-row>
                  </v-col>
                  <v-col>{{ getShopName(shopSelectValues.shop_code) }}</v-col>
                </v-row>
                <v-row class="mb-2">
                  <!-- エリア名 -->
                  <v-col cols="4" class="font-weight-black">
                    <v-row align="center" dense class="py-2 pl-2" justify="end">
                      {{ wordList.lbl_area_name }}
                      <ImportantChip></ImportantChip>
                    </v-row>
                  </v-col>
                  <v-col v-if="processFlag == 0">{{
                    areaEditSelectValues.area_name
                  }}</v-col>
                  <v-col v-if="processFlag > 0">{{
                    getAreaName(deliveryTimeCommonInput.area_code)
                  }}</v-col>
                </v-row>
                <!-- 配達便 -->
                <v-row class="mb-2">
                  <v-col cols="4" class="font-weight-black">
                    <v-row align="center" dense class="py-2 pl-2" justify="end">
                      {{ wordList.lbl_delivery_id }}
                      <ImportantChip></ImportantChip>
                    </v-row>
                  </v-col>
                  <v-col>{{ deliverySelectValues.label }}</v-col>
                </v-row>
                <!-- 配達開始時刻 -->
                <v-row class="mb-2">
                  <v-col cols="4" class="font-weight-black">
                    <v-row align="center" dense class="py-2 pl-2" justify="end">
                      {{ wordList.lbl_delivery_start_time }}
                      <ImportantChip></ImportantChip>
                    </v-row>
                  </v-col>
                  <v-col>{{
                    deliveryTimeCommonInput.delivery_start_time
                  }}</v-col>
                </v-row>
                <!-- 配達終了時刻 -->
                <v-row class="mb-2">
                  <v-col cols="4" class="font-weight-black">
                    <v-row align="center" dense class="py-2 pl-2" justify="end">
                      {{ wordList.lbl_delivery_end_time }}
                      <ImportantChip></ImportantChip>
                    </v-row>
                  </v-col>
                  <v-col>{{ deliveryTimeCommonInput.delivery_end_time }}</v-col>
                </v-row>
                <!-- キャップ設定 -->
                <v-row class="mb-2">
                  <v-col cols="4" class="font-weight-black">
                    <v-row align="center" dense class="py-2 pl-2" justify="end">
                      {{ wordList.lbl_delivery_cap_setting }}
                      <ImportantChip></ImportantChip>
                    </v-row>
                  </v-col>
                  <v-col>{{ selectTimeCapSelectValues.item }}</v-col>
                </v-row>
                <!-- 全曜日 -->
                <v-row v-if="selectTimeCapSelectValues.index == 0" class="mb-2">
                  <v-col cols="4" class="font-weight-black">
                    <v-row align="center" dense class="py-2 pl-2" justify="end">
                      {{ wordList.lbl_max_deliverable_unit }}
                      <ImportantChip></ImportantChip>
                    </v-row>
                  </v-col>
                  <v-col>{{
                    deliveryTimeCommonInput.max_deliverable_unit
                  }}</v-col>
                </v-row>
                <!-- 曜日キャップ数 -->
                <v-row v-if="selectTimeCapSelectValues.index == 1" class="mb-2">
                  <v-col cols="4" class="font-weight-black">
                    <v-row align="center" dense class="py-2 pl-2" justify="end">
                    </v-row>
                  </v-col>
                  <v-col cols="1">{{ wordList.lbl_delivery_cap_mon }}</v-col>
                  <v-col cols="1">{{ wordList.lbl_delivery_cap_tue }}</v-col>
                  <v-col cols="1">{{ wordList.lbl_delivery_cap_wed }}</v-col>
                  <v-col cols="1">{{ wordList.lbl_delivery_cap_thu }}</v-col>
                  <v-col cols="1">{{ wordList.lbl_delivery_cap_fri }}</v-col>
                  <v-col cols="1">{{ wordList.lbl_delivery_cap_sat }}</v-col>
                  <v-col cols="1">{{ wordList.lbl_delivery_cap_sun }}</v-col>
                </v-row>
                <!-- 曜日キャップ数 -->
                <v-row v-if="selectTimeCapSelectValues.index == 1" class="mb-2">
                  <v-col cols="4" class="font-weight-black">
                    <v-row align="center" dense class="py-2 pl-2" justify="end">
                      {{ wordList.lbl_delivery_day_cap }}
                      <ImportantChip></ImportantChip>
                    </v-row>
                  </v-col>
                  <v-col cols="1">
                    {{ deliveryTimeCommonInput.delivery_cap_mon }}
                  </v-col>
                  <v-col cols="1">
                    {{ deliveryTimeCommonInput.delivery_cap_tue }}
                  </v-col>
                  <v-col cols="1">
                    {{ deliveryTimeCommonInput.delivery_cap_wed }}
                  </v-col>
                  <v-col cols="1">
                    {{ deliveryTimeCommonInput.delivery_cap_thu }}
                  </v-col>
                  <v-col cols="1">
                    {{ deliveryTimeCommonInput.delivery_cap_fri }}
                  </v-col>
                  <v-col cols="1">
                    {{ deliveryTimeCommonInput.delivery_cap_sat }}
                  </v-col>
                  <v-col cols="1">
                    {{ deliveryTimeCommonInput.delivery_cap_sun }}
                  </v-col>
                </v-row>
                <!-- 表示設定 -->
                <v-row class="mb-2">
                  <v-col cols="4" class="font-weight-black">
                    <v-row align="center" dense class="py-2 pl-2" justify="end">
                      {{ wordList.lbl_display_setting }}
                      <ImportantChip></ImportantChip>
                    </v-row>
                  </v-col>
                  <v-col>{{ displayDaysSettingValues.label }}</v-col>
                </v-row>
              </v-card-text>
              <v-card-actions class="justify-center">
                <!-- 戻るボタン -->
                <v-btn
                  variant="flat"
                  color="return"
                  class="pa-5 px-16 d-flex align-center"
                  prepend-icon="mdi-arrow-left"
                  @click="onClickConfirmCancel"
                >
                  <span>{{ wordList.btn_return }}</span></v-btn
                >
                <!-- 完了画面ボタン -->
                <v-btn
                  variant="flat"
                  color="primary"
                  class="pa-5 px-16 d-flex align-center"
                  @click="onClickConfirmEntry"
                >
                  <v-icon class="mr-1">mdi-playlist-edit</v-icon>
                  <!-- 登録完了画面ボタン -->
                  <span v-if="processFlag < 2">
                    {{ wordList.btn_regist_complete }}
                  </span>
                  <!-- 削除完了画面ボタン -->
                  <span v-else>
                    {{ wordList.btn_delete_complete }}
                  </span>
                </v-btn>
              </v-card-actions>
              <v-overlay
                :model-value="overlay"
                class="d-flex align-center justify-center"
              >
                <v-progress-circular
                  indeterminate
                  size="64"
                ></v-progress-circular>
              </v-overlay>
            </v-card>
          </v-card>
          <!-- } 配達時間登録確認ダイアログ -->
          <!-- 配達時間登録完了ダイアログ { -->
          <v-card v-if="displayCompletedDialog">
            <v-card
              v-if="
                createDeliveryTimeMutation !== null &&
                createDeliveryTimeMutation !== undefined
              "
            >
              <v-card-title class="mt-3 pb-5 text-h5 font-weight-bold">
                {{ wordList.lbl_delivery_time_regist_complate }}
              </v-card-title>
              <v-card-text>
                <v-row class="pt-5">
                  <v-col class="font-weight-black">
                    {{ wordList.lbl_delivery_time_regist_complete_msg }}
                  </v-col>
                </v-row>
                <!-- 配達便コード -->
                <v-row class="ml-5">
                  <v-col cols="3" class="font-weight-black">
                    {{ wordList.lbl_delivery_id }}
                  </v-col>
                  <v-col cols="9">{{ deliverySelectValues.label }}</v-col>
                </v-row>
                <!-- 配達開始時間 -->
                <v-row class="ml-5">
                  <v-col cols="3" class="font-weight-black">
                    {{ wordList.lbl_delivery_start_time }}
                  </v-col>
                  <v-col cols="9">
                    {{ deliveryTimeCommonInput.delivery_start_time }}
                  </v-col>
                </v-row>
                <!-- 配達終了時間 -->
                <v-row class="ml-5">
                  <v-col cols="3" class="font-weight-black">
                    {{ wordList.lbl_delivery_end_time }}
                  </v-col>
                  <v-col cols="9">{{
                    deliveryTimeCommonInput.delivery_end_time
                  }}</v-col>
                </v-row>
                <!-- 基本キャップ数 -->
                <v-row class="ml-5">
                  <v-col cols="3" class="font-weight-black">
                    {{ wordList.lbl_max_deliverable_unit }}
                  </v-col>
                  <v-col cols="9">
                    {{ deliveryTimeCommonInput.max_deliverable_unit }}
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions class="justify-center">
                <v-btn
                  variant="flat"
                  class="px-16"
                  @click="onClickCompletedGoStart"
                >
                  <v-card-text>
                    {{ wordList.btn_delivery_time_regist_rerutn }}
                  </v-card-text>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-card>
          <!-- } エリア登録完了ダイアログ -->
          <AlertDialog
            v-model="errdialog"
            :title="wordList.lbl_err_dialog_title"
            :message="errMessage"
            type="error"
          />
      </v-tabs-window-item>
      <!-- } 配達時間設定タブ -->
      <!-- 配達グループ設定タブ { -->
      <v-tabs-window-item :value="1">
          <v-card
            v-if="
              !displayInputDialog &&
              !displayConfirmDialog &&
              !displayCompletedDialog
            "
            flat
          >
            <!-- 検索条件入力 { -->
            <form>
              <v-card flat class="mt-5">
                <v-expansion-panels v-model="panel" flat multiple class="br_1">
                  <v-expansion-panel>
                    <v-expansion-panel-title class="d-none"></v-expansion-panel-title>
                    <v-expansion-panel-text class="bk_gray_3">
                      <v-card-text>
                        <v-row class="pt-4">
                          <!-- チェーン名 -->
                          <v-col v-if="chainViewFlag" sm="6" md="4" class="py-0">
                            <v-autocomplete
                              v-model="chainSelectValues"
                              density="compact"
                              :items="chainListItems"
                              item-title="name"
                              item-value="chain_code"
                              :label="wordList.lbl_chain_name"
                              :placeholder="wordList.plc_selectbox"
                              :no-data-text="wordList.lbl_no_data_text"
                              bg-color="white"
                              return-object
                              variant="outlined"
                              @update:model-value="onChangeChain"
                            ></v-autocomplete>
                          </v-col>
                          <!-- グループ名 -->
                          <v-col sm="6" md="4" class="py-0">
                            <v-autocomplete
                              v-model="deliveryGroupSelectValues"
                              density="compact"
                              :items="deliveryGroupListItems"
                              item-title="name"
                              item-value="group_code"
                              :label="wordList.lbl_delivery_group_name"
                              :error-messages="errors"
                              :no-data-text="wordList.lbl_no_data_text"
                              bg-color="white"
                              return-object
                              variant="outlined"
                              @update:model-value="onChangeGroup"
                            ></v-autocomplete>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-expansion-panel-text>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-card>
            </form>
            <!-- 検索条件入力 } -->
            <v-row class="justify-end mt-5" style="width: 100%">
              <v-btn
                color="primary"
                class="mb-2 px-10"
                :disabled="chainSelectValues.chain_code.length == 0"
                @click="onClickNewRegister"
              >
                {{ wordList.lbl_new_group_add }}
              </v-btn>
            </v-row>
            <v-data-table
              :items="listGroupDeliveryIdDataArray"
              :headers="groupTableHeaders"
              :no-data-text="wordList.lbl_no_data_text"
              hide-default-footer
            >
              <template #[`item.assigned_id_list`]="{ item }">
                <div
                  v-for="assigned_id_name in item.assigned_id_list"
                  :key="assigned_id_name"
                >
                  <span>{{ assigned_id_name }}</span>
                </div>
              </template>
              <template #[`item.actions`]="{ item }">
                <div>
                  <v-btn
                    variant="outlined"
                    color="primary"
                    class="my-2 ml-2 rounded-full"
                    size="x-small"
                    icon
                    @click="onClickEdit(item)"
                  >
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                  <v-btn
                    variant="outlined"
                    color="red"
                    class="my-2 ml-2 mr-0 rounded-full"
                    size="x-small"
                    icon
                    @click="onClickDelete(item)"
                  >
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </div>
              </template>
            </v-data-table>
          </v-card>
          <!-- 配達グループ登録 { -->
          <v-card v-if="displayInputDialog && mode === 'group'" class="mt-10">
            <Form v-slot="{ invalid, validate }" ref="groupFormRef">
              <v-card>
                <v-card-title
                  v-if="processFlag == 0"
                  class="mt-3 pb-5 text-h5 font-weight-bold"
                >
                  {{ wordList.lbl_delivery_group_regist }}
                </v-card-title>
                <v-card-title
                  v-if="processFlag == 1"
                  class="mt-3 pb-5 text-h5 font-weight-bold"
                >
                  {{ wordList.lbl_delivery_group_edit }}
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row
                      v-if="processFlag == 0"
                        class="mb-5"
                    >
                      <v-col cols="4"> </v-col>
                      <v-col cols="6">
                        <Field
                          v-slot="{ errors, field }"
                          :name="fieldName('lbl_cur_deliverable_display_method')"
                          rules="required"
                        >
                          <v-radio-group
                            :model-value="selectTypeSelectValues.index"
                            inline
                            mandatory
                            :error-messages="errors"
                            class="mt-0"
                            @update:model-value="(value) => { selectTypeSelectValues.index = value; field.onChange(value); syncGroupFormValues(); }"
                            @blur="field.onBlur"
                          >
                            <v-radio
                              v-for="item in selectTypeItems"
                              :key="item.index"
                              :label="item.item"
                              :value="item.index"
                              color="indigo"
                              density="compact"
                            ></v-radio>
                          </v-radio-group>
                        </Field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <!-- 配達グループ -->
                      <v-col cols="4" class="font-weight-black">
                        <v-row align="center" dense class="form-label-row mr-3" justify="end">
                          {{ wordList.lbl_delivery_group_name }}
                          <ImportantChip></ImportantChip>
                        </v-row>
                      </v-col>
                      <v-col v-if="processFlag == 0" cols="4">
                        <Field
                          v-if="selectTypeSelectValues.index == 0"
                          v-slot="{ errors, field }"
                          :name="fieldName('lbl_delivery_group_name')"
                          rules="required"
                        >
                          <v-text-field
                            v-model="deliveryGroupCreateInput.name"
                            density="compact"
                            variant="outlined"
                            :placeholder="wordList.lbl_delivery_group_name"
                            :error-messages="errors"
                            @update:model-value="field.onChange"
                            @blur="field.onBlur"
                          ></v-text-field>
                        </Field>
                        <Field
                          v-if="selectTypeSelectValues.index == 1"
                          v-slot="{ errors, field }"
                          :name="fieldName('lbl_delivery_group_name')"
                          rules="required"
                        >
                          <v-autocomplete
                            v-model="deliveryGroupSelectValues"
                            density="compact"
                            :items="deliveryGroupListItems"
                            item-title="name"
                            item-value="group_code"
                            :label="wordList.lbl_delivery_group_name"
                            :error-messages="errors"
                            :no-data-text="wordList.lbl_no_data_text"
                            bg-color="white"
                            return-object
                            variant="outlined"
                            @update:model-value="field.onChange"
                            @blur="field.onBlur"
                          ></v-autocomplete>
                        </Field>
                      </v-col>
                      <v-col v-if="processFlag == 1" cols="6" class="mb-8">
                        <Field
                          v-if="processFlag == 1"
                          v-slot="{ errors, field }"
                          :name="fieldName('lbl_delivery_group_name')"
                          rules="required"
                        >
                          <v-text-field
                            v-model="deliveryGroupUpdateInput.name"
                            density="compact"
                            variant="outlined"
                            :placeholder="wordList.lbl_delivery_group_name"
                            :error-messages="errors"
                            @update:model-value="field.onChange"
                            @blur="field.onBlur"
                          ></v-text-field>
                        </Field>
                      </v-col>
                      <v-col v-if="processFlag == 2" cols="6" class="mb-8">
                        {{ deliveryGroupUpdateInput.name }}
                      </v-col>
                    </v-row>
                    <v-row>
                      <!-- 配達便 -->
                      <v-col cols="4" class="font-weight-black">
                        <v-row align="center" dense class="form-label-row mr-3" justify="end">
                          {{ wordList.lbl_delivery_id }}
                          <ImportantChip></ImportantChip>
                        </v-row>
                      </v-col>
                      <v-col v-if="processFlag == 0" cols="4">
                        <Field
                          v-slot="{ errors, field }"
                          :name="fieldName('lbl_delivery_id')"
                          rules="required"
                        >
                          <v-autocomplete
                            v-model="deliverySelectValues"
                            density="compact"
                            :items="groupDeliveryItems"
                            item-title="label"
                            item-value="delivery_id"
                            :label="wordList.lbl_delivery_id"
                            :error-messages="errors"
                            :no-data-text="wordList.lbl_no_data_text"
                            bg-color="white"
                            return-object
                            variant="outlined"
                            @update:model-value="field.onChange"
                            @blur="(event) => { field.onBlur(event); onBlurDeliveryId(); }"
                          ></v-autocomplete>
                        </Field>
                      </v-col>
                      <v-col v-if="processFlag > 0" cols="6" class="mb-8">
                        {{ deliverySelectValues.label }}
                      </v-col>
                    </v-row>
                    <v-row>
                      <!-- 対象エリア・便 -->
                      <v-col cols="4" class="font-weight-black">
                        <v-row align="center" dense class="form-label-row mr-3" justify="end">
                          {{ wordList.lbl_target_area_delivery_id }}
                          <ImportantChip></ImportantChip>
                        </v-row>
                      </v-col>
                      <v-col cols="4">
                        <v-col v-if="selectListCheckbox.length > 0">
                          <div
                            v-for="selectItem in selectListCheckbox"
                            :key="selectItem.id"
                          >
                            <span>{{
                              selectItem.shop_name +
                              " " +
                              selectItem.area_name +
                              " " +
                              selectItem.delivery_id +
                              " " +
                              selectItem.delivery_time
                            }}</span>
                          </div>
                        </v-col>
                        <v-btn
                          variant="flat"
                          class="px-16"
                          @click="onClickAreaDeliveyIdResist"
                        >
                          {{ wordList.btn_delivery_area_regist }}</v-btn
                        >
                      </v-col>
                    </v-row>
                    <!-- キャップ数設定 -->
                    <v-row>
                      <v-col cols="4" class="font-weight-black">
                        <v-row align="center" dense class="form-label-row mr-3" justify="end">
                          {{ wordList.lbl_delivery_cap_setting }}
                          <ImportantChip></ImportantChip>
                        </v-row>
                      </v-col>
                      <v-col cols="6">
                        <Field
                          v-slot="{ errors, field }"
                          :name="fieldName('lbl_delivery_cap_setting')"
                          rules="required"
                        >
                          <v-radio-group
                            v-model="selectGroupCapSelectValues.index"
                            inline
                            mandatory
                            :error-messages="errors"
                            class="mt-0"
                            @update:model-value="(value) => { field.onChange(value); onChangeCapSelect(); }"
                            @blur="field.onBlur"
                          >
                            <v-radio
                              v-for="item in selectGroupCapItems"
                              :key="item.index"
                              :label="item.item"
                              :value="item.index"
                              color="indigo"
                              density="compact"
                            ></v-radio>
                          </v-radio-group>
                        </Field>
                      </v-col>
                    </v-row>
                    <!-- 基本キャップ数 -->
                    <v-row
                      v-if="selectGroupCapSelectValues.index == 0"
                    >
                      <v-col cols="4" class="font-weight-black">
                        <v-row align="center" dense class="form-label-row mr-3" justify="end">
                          {{ wordList.lbl_max_deliverable_unit }}
                          <ImportantChip></ImportantChip>
                        </v-row>
                      </v-col>
                      <v-col cols="1" class="px-1">
                        <Field
                          v-slot="{ errors, field }"
                          :name="fieldName('lbl_max_deliverable_unit')"
                          rules="required|numeric|max:3"
                        >
                          <v-text-field
                            v-model="
                              deliveryGroupCreateInput.max_deliverable_unit
                            "
                            density="compact"
                            variant="outlined"
                            :error-messages="errors"
                            style="min-width: 80px;"
                            @update:model-value="field.onChange"
                            @blur="field.onBlur"
                          ></v-text-field>
                        </Field>
                      </v-col>
                    </v-row>
                    <!-- 曜日キャップ数 -->
                    <v-row
                      v-if="selectGroupCapSelectValues.index == 1"
                    >
                      <v-col cols="4" class="font-weight-black">
                        <v-row align="center" dense class="form-label-row mr-3" justify="end">
                          {{ wordList.lbl_delivery_day_cap }}
                          <ImportantChip></ImportantChip>
                        </v-row>
                      </v-col>
                      <!-- 月曜日 -->
                      <v-col cols="1" class="px-1">
                        <Field
                          v-slot="{ errors, field }"
                          :name="fieldName('lbl_delivery_cap_mon')"
                          rules="required|numeric|max:3"
                        >
                          <v-text-field
                            v-model="deliveryGroupCreateInput.group_cap_mon"
                            density="compact"
                            :label="wordList.lbl_delivery_cap_mon"
                            variant="outlined"
                            :error-messages="errors"
                            @update:model-value="field.onChange"
                            @blur="field.onBlur"
                          ></v-text-field>
                        </Field>
                      </v-col>
                      <!-- 火曜日 -->
                      <v-col cols="1" class="px-1">
                        <Field
                          v-slot="{ errors, field }"
                          :name="fieldName('lbl_delivery_cap_tue')"
                          rules="required|numeric|max:3"
                        >
                          <v-text-field
                            v-model="deliveryGroupCreateInput.group_cap_tue"
                            density="compact"
                            :label="wordList.lbl_delivery_cap_tue"
                            variant="outlined"
                            :error-messages="errors"
                            @update:model-value="field.onChange"
                            @blur="field.onBlur"
                          ></v-text-field>
                        </Field>
                      </v-col>
                      <!-- 水曜日 -->
                      <v-col cols="1" class="px-1">
                        <Field
                          v-slot="{ errors, field }"
                          :name="fieldName('lbl_delivery_cap_wed')"
                          rules="required|numeric|max:3"
                        >
                          <v-text-field
                            v-model="deliveryGroupCreateInput.group_cap_wed"
                            density="compact"
                            :label="wordList.lbl_delivery_cap_wed"
                            variant="outlined"
                            :error-messages="errors"
                            @update:model-value="field.onChange"
                            @blur="field.onBlur"
                          ></v-text-field>
                        </Field>
                      </v-col>
                      <!-- 木曜日 -->
                      <v-col cols="1" class="px-1">
                        <Field
                          v-slot="{ errors, field }"
                          :name="fieldName('lbl_delivery_cap_thu')"
                          rules="required|numeric|max:3"
                        >
                          <v-text-field
                            v-model="deliveryGroupCreateInput.group_cap_thu"
                            density="compact"
                            :label="wordList.lbl_delivery_cap_thu"
                            variant="outlined"
                            :error-messages="errors"
                            @update:model-value="field.onChange"
                            @blur="field.onBlur"
                          ></v-text-field>
                        </Field>
                      </v-col>
                      <!-- 金曜日 -->
                      <v-col cols="1" class="px-1">
                        <Field
                          v-slot="{ errors, field }"
                          :name="fieldName('lbl_delivery_cap_fri')"
                          rules="required|numeric|max:3"
                        >
                          <v-text-field
                            v-model="deliveryGroupCreateInput.group_cap_fri"
                            density="compact"
                            :label="wordList.lbl_delivery_cap_fri"
                            variant="outlined"
                            :error-messages="errors"
                            @update:model-value="field.onChange"
                            @blur="field.onBlur"
                          ></v-text-field>
                        </Field>
                      </v-col>
                      <!-- 土曜日 -->
                      <v-col cols="1" class="px-1">
                        <Field
                          v-slot="{ errors, field }"
                          :name="fieldName('lbl_delivery_cap_sat')"
                          rules="required|numeric|max:3"
                        >
                          <v-text-field
                            v-model="deliveryGroupCreateInput.group_cap_sat"
                            density="compact"
                            :label="wordList.lbl_delivery_cap_sat"
                            variant="outlined"
                            :error-messages="errors"
                            @update:model-value="field.onChange"
                            @blur="field.onBlur"
                          ></v-text-field>
                        </Field>
                      </v-col>
                      <!-- 日曜日 -->
                      <v-col cols="1" class="px-1">
                        <Field
                          v-slot="{ errors, field }"
                          :name="fieldName('lbl_delivery_cap_sun')"
                          rules="required|numeric|max:3"
                        >
                          <v-text-field
                            v-model="deliveryGroupCreateInput.group_cap_sun"
                            density="compact"
                            :label="wordList.lbl_delivery_cap_sun"
                            variant="outlined"
                            :error-messages="errors"
                            @update:model-value="field.onChange"
                            @blur="field.onBlur"
                          ></v-text-field>
                        </Field>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-card-actions class="justify-center py-10">
                  <!-- 戻るボタン -->
                  <v-btn
                    variant="flat"
                    color="return"
                    class="px-16"
                    @click="onClickInputCancel"
                  >
                    <v-icon>mdi-arrow-left</v-icon>
                    {{ wordList.btn_return }}</v-btn
                  >
                  <!-- 確認画面へボタン -->
                  <v-btn
                    variant="flat"
                    color="primary"
                    class="px-16"
                    :disabled="!isGroupFormValid"
                    @click="onClickOpenConfirmDialog(validate)"
                  >
                    <v-icon>mdi-playlist-edit</v-icon>
                    {{ wordList.btn_regist_confirm }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </Form>
          </v-card>
          <!-- 対象エリア・便登録ダイアログ { -->
          <v-dialog
            v-model="areaDeliveryIdResistDialog"
            persistent
            width="80%"
            @keydown.enter="areaDeliveryIdResistDialog = false"
          >
            <v-card align="center">
              <v-card-title class="mt-3 pb-5 text-h5 font-weight-bold d-flex justify-space-between align-center">
                <div>{{ wordList.lbl_target_area_delivery_id_select }}</div>
                <v-btn
                  variant="text"
                  icon="mdi-close"
                  @click="onClickAreaDeliveyIdCancel"
                ></v-btn>
              </v-card-title>
              <v-row class="pt-4 px-4" style="max-width: 95%">
                <!-- 店舗名 -->
                <v-col sm="6" md="4" class="py-0">
                  <v-autocomplete
                    v-model="shopSelectValues"
                    density="compact"
                    :items="shopListItems"
                    item-title="name"
                    item-value="shop_code"
                    :label="wordList.lbl_shop_name"
                    :placeholder="wordList.plc_selectbox"
                    :no-data-text="wordList.lbl_no_data_text"
                    return-object
                    variant="outlined"
                    @update:model-value="onChangeShopAreaDeliveyIdResist"
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <!-- 店舗未選択時のメッセージ -->
              <div
                v-if="!shopSelectValues || !shopSelectValues.shop_code"
                class="text-center text-grey pa-8"
              >
                店舗を選択してください
              </div>
              <!-- ローディングインジケーター -->
              <v-progress-linear
                v-if="isLoadingAreaDelivery"
                indeterminate
                color="primary"
                class="mx-4"
              ></v-progress-linear>
              <v-expansion-panels v-if="shopSelectValues && shopSelectValues.shop_code" v-model="panel" flat multiple class="br_1">
                <v-expansion-panel style="max-width: 95%">
                  <v-expansion-panel-title class="d-none"></v-expansion-panel-title>
                  <v-expansion-panel-text class="bk_gray_3">
                    <v-data-table
                      v-model:options="listOptions"
                      :items="listDataAreaDeliveryIdResistArray"
                      :headers="areaDeliveryIdResistHeaders"
                      :no-data-text="wordList.lbl_no_data_text"
                      :items-per-page="listOptions.itemsPerPage"
                      hide-default-footer
                      :sort-by="['shop_code', 'area_code']"
                      item-key="id"
                      class="area-delivery-table"
                      style="max-width: 95%"
                    >
                      <template #body="{ items }">
                        <tr v-for="item in items" :key="item.id">
                          <td
                            v-if="item.shop_cnt > 0"
                            class="text-center"
                            :rowspan="item.shop_cnt"
                          >
                            {{ item.shop_name }}
                          </td>
                          <td class="text-center">
                            {{ item.area_name }}
                          </td>
                          <td class="text-center">{{ item.delivery_id }}</td>
                          <td class="text-center">{{ item.delivery_time }}</td>
                          <td class="text-center">
                            <v-checkbox
                              v-model="selectListCheckbox"
                              :value="item"
                              :disabled="item.use_flg === true"
                              hide-details
                            ></v-checkbox>
                          </td>
                        </tr>
                      </template>
                    </v-data-table>
                    <!-- ページネーション -->
                    <div class="d-flex justify-center align-center mt-3">
                      <v-pagination
                        v-model="areaDeliveryCurrentPage"
                        :length="Math.ceil(areaDeliveryTotalCount / 50)"
                        :total-visible="7"
                        density="comfortable"
                        @update:model-value="onPageChangeAreaDeliveyIdResist"
                      ></v-pagination>
                    </div>
                    <div class="text-center text-caption text-grey mb-2">
                      {{ areaDeliveryTotalCount }} 件中
                      {{ (areaDeliveryCurrentPage - 1) * 50 + 1 }}〜{{ Math.min(areaDeliveryCurrentPage * 50, areaDeliveryTotalCount) }} 件表示
                    </div>
                    <v-btn
                      variant="outlined"
                      class="mt-4 mb-3"
                      color="primary"
                      @click="areaDeliveryIdResistDialog = false"
                      >{{ wordList.btn_select_resist }}</v-btn
                    >
                  </v-expansion-panel-text>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-card>
          </v-dialog>
          <!-- }対象エリア・便登録ダイアログ -->
          <!-- } 配達グループ登録確認 -->
          <v-card v-if="displayConfirmDialog && mode === 'group'" class="mt-10">
            <v-card>
              <v-card-title
                v-if="processFlag == 0"
                class="mt-3 pb-5 text-h5 font-weight-bold"
              >
                {{ wordList.lbl_group_regist_confirm }}
              </v-card-title>
              <v-card-title
                v-if="processFlag == 1"
                class="mt-3 pb-5 text-h5 font-weight-bold"
              >
                {{ wordList.lbl_group_edit_confirm }}
              </v-card-title>
              <v-card-title
                v-if="processFlag == 2"
                class="mt-3 pb-5 text-h5 font-weight-bold"
              >
                {{ wordList.lbl_group_delete_confirm }}
              </v-card-title>
              <v-card-text style="" class="pt-5 confirm-display-text">
                <!-- 配達グループ -->
                <v-row class="mb-2">
                  <v-col cols="4" class="font-weight-black">
                    <v-row align="center" dense class="py-2 pl-2" justify="end">
                      {{ wordList.lbl_delivery_group_name }}
                      <ImportantChip></ImportantChip>
                    </v-row>
                  </v-col>
                  <v-col v-if="selectTypeSelectValues.index == 0">{{
                    deliveryGroupCreateInput.name
                  }}</v-col>
                  <v-col v-if="selectTypeSelectValues.index == 1">{{
                    deliveryGroupCreateInput.name
                  }}</v-col>
                </v-row>
                <!-- 配達便 -->
                <v-row class="mb-2">
                  <v-col cols="4" class="font-weight-black">
                    <v-row align="center" dense class="py-2 pl-2" justify="end">
                      {{ wordList.lbl_delivery_id }}
                      <ImportantChip></ImportantChip>
                    </v-row>
                  </v-col>
                  <v-col>{{ deliverySelectValues.label }}</v-col>
                </v-row>
                <!-- 対象エリア・便 -->
                <v-row class="mb-2">
                  <v-col cols="4" class="font-weight-black">
                    <v-row align="center" dense class="py-2 pl-2" justify="end">
                      {{ wordList.lbl_target_area_delivery_id }}
                      <ImportantChip></ImportantChip>
                    </v-row>
                  </v-col>
                  <v-col v-if="selectListCheckbox.length > 0">
                    <div
                      v-for="selectItem in selectListCheckbox"
                      :key="selectItem.id"
                    >
                      <span>{{
                        selectItem.shop_name +
                        " " +
                        selectItem.area_name +
                        " " +
                        selectItem.delivery_id +
                        " " +
                        selectItem.delivery_time
                      }}</span>
                    </div>
                  </v-col>
                </v-row>
                <!-- キャップ設定 -->
                <v-row class="mb-2">
                  <v-col cols="4" class="font-weight-black">
                    <v-row align="center" dense class="py-2 pl-2" justify="end">
                      {{ wordList.lbl_delivery_cap_setting }}
                      <ImportantChip></ImportantChip>
                    </v-row>
                  </v-col>
                  <v-col>{{ selectGroupCapSelectValues.item }}</v-col>
                </v-row>
                <!-- 基本キャップ数 -->
                <v-row
                  v-if="selectGroupCapSelectValues.index == 0"
                    class="mb-2"
                >
                  <v-col cols="4" class="font-weight-black">
                    <v-row align="center" dense class="py-2 pl-2" justify="end">
                      {{ wordList.lbl_max_deliverable_unit }}
                      <ImportantChip></ImportantChip>
                    </v-row>
                  </v-col>
                  <v-col>{{
                    deliveryGroupCreateInput.max_deliverable_unit
                  }}</v-col>
                </v-row>
                <!-- 曜日キャップ数 -->
                <v-row
                  v-if="selectGroupCapSelectValues.index == 1"
                    class="mb-2"
                >
                  <v-col cols="4" class="font-weight-black">
                    <v-row align="center" dense class="py-2 pl-2" justify="end">
                    </v-row>
                  </v-col>
                  <v-col cols="1">{{ wordList.lbl_delivery_cap_mon }}</v-col>
                  <v-col cols="1">{{ wordList.lbl_delivery_cap_tue }}</v-col>
                  <v-col cols="1">{{ wordList.lbl_delivery_cap_wed }}</v-col>
                  <v-col cols="1">{{ wordList.lbl_delivery_cap_thu }}</v-col>
                  <v-col cols="1">{{ wordList.lbl_delivery_cap_fri }}</v-col>
                  <v-col cols="1">{{ wordList.lbl_delivery_cap_sat }}</v-col>
                  <v-col cols="1">{{ wordList.lbl_delivery_cap_sun }}</v-col>
                </v-row>
                <v-row
                  v-if="selectGroupCapSelectValues.index == 1"
                    class="mb-2"
                >
                  <!-- 曜日キャップ数 -->
                  <v-col cols="4" class="font-weight-black">
                    <v-row align="center" dense class="py-2 pl-2" justify="end">
                      {{ wordList.lbl_delivery_day_cap }}
                      <ImportantChip></ImportantChip>
                    </v-row>
                  </v-col>
                  <v-col cols="1">
                    {{ deliveryGroupCreateInput.group_cap_mon }}
                  </v-col>
                  <v-col cols="1">
                    {{ deliveryGroupCreateInput.group_cap_tue }}
                  </v-col>
                  <v-col cols="1">
                    {{ deliveryGroupCreateInput.group_cap_wed }}
                  </v-col>
                  <v-col cols="1">
                    {{ deliveryGroupCreateInput.group_cap_thu }}
                  </v-col>
                  <v-col cols="1">
                    {{ deliveryGroupCreateInput.group_cap_fri }}
                  </v-col>
                  <v-col cols="1">
                    {{ deliveryGroupCreateInput.group_cap_sat }}
                  </v-col>
                  <v-col cols="1">
                    {{ deliveryGroupCreateInput.group_cap_sun }}
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions class="justify-center">
                <!-- 戻るボタン -->
                <v-btn
                  variant="flat"
                  color="return"
                  class="pa-5 px-16 d-flex align-center"
                  prepend-icon="mdi-arrow-left"
                  @click="onClickConfirmCancel"
                >
                  <span>{{ wordList.btn_return }}</span></v-btn
                >
                <!-- 完了画面ボタン -->
                <v-btn
                  variant="flat"
                  color="primary"
                  class="pa-5 px-16 d-flex align-center"
                  @click="onClickConfirmEntry"
                >
                  <v-icon class="mr-1">mdi-playlist-edit</v-icon>
                  <!-- 登録完了画面ボタン -->
                  <span v-if="processFlag < 2">
                    {{ wordList.btn_regist_complete }}
                  </span>
                  <!-- 削除完了画面ボタン -->
                  <span v-else>
                    {{ wordList.btn_delete_complete }}
                  </span>
                </v-btn>
              </v-card-actions>
              <v-overlay
                :model-value="overlay"
                class="d-flex align-center justify-center"
              >
                <v-progress-circular
                  indeterminate
                  size="64"
                ></v-progress-circular>
              </v-overlay>
            </v-card>
          </v-card>
          <!-- } 配達グループ登録確認 -->
      </v-tabs-window-item>
    </v-tabs-window>
  </v-container>
</template>

<script setup lang="ts">
import { reactive, ref } from "vue";
import { Form, Field } from "vee-validate";
import ImportantChip from "@/components/ImportantChip.vue";
import AlertDialog from "@/components/AlertDialog.vue";

// Composable imports
import { useDeliverySettingUiState } from "./composables/useDeliverySettingUiState";
import { useDeliverySettingFilterState, useDeliverySettingFilter } from "./composables/useDeliverySettingFilter";
import { useDeliverySettingActionsState, useDeliverySettingActions } from "./composables/useDeliverySettingActions";
import { useDeliverySettingInit } from "./composables/useDeliverySettingInit";
import { useDeliverySettingTimeList } from "./composables/useDeliverySettingTimeList";
import { useDeliverySettingTimeForm } from "./composables/useDeliverySettingTimeForm";
import { useDeliverySettingGroupList } from "./composables/useDeliverySettingGroupList";
import { useDeliverySettingGroupForm } from "./composables/useDeliverySettingGroupForm";
import { useDeliverySettingApi } from "./composables/useDeliverySettingApi";

// Constants
import {
  DELIVERY_ITEMS,
  GROUP_DELIVERY_ITEMS,
  DISPLAY_DAYS_SETTING_ITEMS,
  TABLE_HEADERS,
  GROUP_TABLE_HEADERS,
  AREA_DELIVERY_ID_RESIST_HEADERS,
} from "./constants";

// Types
import type { ListOptions } from "./types";

// テンプレート用定数エイリアス（元のテンプレートで使用されている変数名を維持）
const deliveryItems = DELIVERY_ITEMS;
const groupDeliveryItems = GROUP_DELIVERY_ITEMS;
const displayDaysSettingItem = DISPLAY_DAYS_SETTING_ITEMS;
const tableHeaders = TABLE_HEADERS;
const groupTableHeaders = GROUP_TABLE_HEADERS;
const areaDeliveryIdResistHeaders = AREA_DELIVERY_ID_RESIST_HEADERS;

// === 1. UI State ===
const {
  overlay, errdialog, errMessage, processFlag, mode,
  model, panel, displayInputDialog, displayConfirmDialog,
  displayCompletedDialog, areaDeliveryIdResistDialog,
  completeFlg, selectShopFlg, selectAreaFlg,
  timeFormRef, groupFormRef,
} = useDeliverySettingUiState();

// === 2. Filter State（循環依存を解消するため先にstateのみ生成） ===
const filterState = useDeliverySettingFilterState();
const {
  chainListItems, chainSelectValues, shopListItems, shopSelectValues,
  areaListItems, newAreaListItems, areaSelectValues, areaEditSelectValues,
  deliveryGroupListItems, deliveryGroupSelectValues, bufDeliveryGroupSelectValues,
  shopListInput, deliveryTimeListInput, deliveryTimeAllListInput,
  deliveryTimeCommonInput, deliveryTimeDeleteInput,
  deliveryTimeGetInput,
  deliveryGroupListInput, deliveryGroupGetInput,
  listDataArray, listGroupDeliveryIdDataArray, mappedListData,
  listDeliveryTime,
} = filterState;

// === 3. Actions State ===
const {
  deliverySelectValues, displayDaysSettingValues,
  selectTypeItems, selectTypeSelectValues,
  selectTimeCapItems, selectTimeCapSelectValues,
  selectGroupCapItems, selectGroupCapSelectValues,
  selectListCheckbox, listDeliveryTimeAll, listDataAreaDeliveryIdResistArray,
  areaDeliveryCurrentPage, areaDeliveryTotalCount, isLoadingAreaDelivery,
  deliveryGroupCreateInput, deliveryGroupUpdateInput, deliveryGroupDeleteInput,
  use_list,
} = useDeliverySettingActionsState();

// === 4. 共有ステート ===
// 文言リスト
const wordList = reactive<Record<string, string>>({});

// テーブルオプション設定
const listOptions = ref<ListOptions>({
  page: 1,
  itemsPerPage: 1000,
  sortBy: [],
  sortDesc: [],
  groupBy: [],
  groupDesc: [],
  multiSort: false,
  mustSort: false,
});

// グループタブフィルター用（テンプレートで参照）
const errors = ref<string[]>([]);

// === 5. ヘルパー関数 ===
const fieldName = (key: string): string => {
  return wordList[key] || key;
};

const getAreaName = (area_code: string): string => {
  let area_name = "";
  const list = Array.isArray(areaListItems.value) ? areaListItems.value : [];
  list.forEach((value) => {
    if (
      value &&
      value.area_code === area_code &&
      value.area_name
    ) {
      area_name = value.area_name;
    }
  });
  return area_name;
};

/**
 * チェーン名を取得
 */
const getChainName = (chain_code: string): string => {
  let chain_name = "";
  const list = Array.isArray(chainListItems.value) ? chainListItems.value : [];
  list.forEach((value) => {
    if (
      value &&
      value.chain_code === chain_code &&
      value.name
    ) {
      chain_name = value.name;
    }
  });
  return chain_name;
};

/**
 * 店舗名を取得
 */
const getShopName = (shop_code: string): string => {
  let shop_name = "";
  const list = Array.isArray(shopListItems.value) ? shopListItems.value : [];
  list.forEach((value) => {
    if (
      value &&
      value.shop_code === shop_code &&
      value.name
    ) {
      shop_name = value.name;
    }
  });
  return shop_name;
};

/**
 * 便名を取得
 */
const getDeliveryIdName = (delivery_id: number): string => {
  let delivery_id_name = "";
  deliveryItems.forEach((value) => {
    if (value.delivery_id === delivery_id) {
      delivery_id_name = value.label;
    }
  });
  return delivery_id_name;
};

// === 6. Composable ワイヤリング ===

// 配達時間一覧
const { queryDeliverytime } = useDeliverySettingTimeList({
  deliveryTimeListInput,
  listDeliveryTime,
  listDataArray,
  mappedListData,
  areaListItems,
});

// 配達グループ一覧
const { listGroupDeliveryId, onChangeGroup } = useDeliverySettingGroupList({
  chainSelectValues,
  deliveryGroupSelectValues,
  deliveryGroupGetInput,
  listGroupDeliveryIdDataArray,
  areaListItems,
  shopListItems,
  getAreaName,
  getShopName,
  getDeliveryIdName,
});

// 配達時間フォーム
const {
  isTimeFormValid,
  isValidNumberValue,
  onChangeDeliveryStartTime,
  onChangeDeliveryEndTime,
  syncTimeFormValues,
} = useDeliverySettingTimeForm({
  processFlag,
  mode,
  errdialog,
  errMessage,
  timeFormRef,
  deliveryTimeCommonInput,
  areaEditSelectValues,
  deliverySelectValues,
  selectTimeCapSelectValues,
  displayDaysSettingValues,
  wordList,
});

// 配達グループフォーム
const { isGroupFormValid, syncGroupFormValues } = useDeliverySettingGroupForm({
  processFlag,
  mode,
  groupFormRef,
  deliveryGroupCreateInput,
  deliveryGroupUpdateInput,
  deliverySelectValues,
  deliveryGroupSelectValues,
  selectTypeSelectValues,
  selectGroupCapSelectValues,
  selectListCheckbox,
  wordList,
  isValidNumberValue,
});

// フィルター（事前生成したfilterStateを渡して重複生成を防止）
const {
  onChangeChain,
  onChangeShop,
  onChangeArea,
  onClickGroupTab,
  onClickTimeTab,
} = useDeliverySettingFilter({
  errdialog,
  errMessage,
  displayInputDialog,
  displayConfirmDialog,
  selectShopFlg,
  selectAreaFlg,
  mode,
  model,
  queryDeliverytime,
  onChangeGroup,
  filterState,
});

// API
const {
  createDeliveryTimeMutation,
  createDeliveryGroupMutation,
  updateDeliveryGroupMutation,
  createDeliveryTime,
  createDeliveryGroup,
  chkDeliveryId,
  chkDeliveryIdType,
  chkGroupDeliveryId,
  getGroupList,
  getDelivery,
} = useDeliverySettingApi({
  errdialog,
  errMessage,
  overlay,
  processFlag,
  mode,
  completeFlg,
  chainSelectValues,
  shopSelectValues,
  areaSelectValues,
  areaEditSelectValues,
  deliverySelectValues,
  displayDaysSettingValues,
  selectTimeCapSelectValues,
  selectGroupCapSelectValues,
  selectTypeSelectValues,
  deliveryGroupSelectValues,
  deliveryTimeCommonInput,
  deliveryTimeDeleteInput,
  deliveryGroupCreateInput,
  deliveryGroupUpdateInput,
  deliveryGroupDeleteInput,
  deliveryTimeGetInput,
  deliveryTimeListInput,
  deliveryTimeAllListInput,
  deliveryGroupListInput,
  deliveryGroupGetInput,
  selectListCheckbox,
  listGroupDeliveryIdDataArray,
  deliveryGroupListItems,
  listDeliveryTimeAll,
  listDataAreaDeliveryIdResistArray,
  listGroupDeliveryId,
  areaListItems,
  use_list,
  getAreaName,
  getShopName,
  getDeliveryIdName,
});

// アクション
const {
  onChangeCapSelect,
  onClickNewRegister,
  onClickEdit,
  onClickDelete,
  onBlurDeliveryId,
  onClickInputCancel,
  onClickOpenConfirmDialog,
  onClickAreaDeliveyIdResist,
  onClickAreaDeliveyIdCancel,
  onClickConfirmEntry,
  onClickConfirmCancel,
  onChangeShopAreaDeliveyIdResist,
  onPageChangeAreaDeliveyIdResist,
  onClickCompletedGoStart,
} = useDeliverySettingActions({
  overlay,
  errdialog,
  errMessage,
  processFlag,
  mode,
  displayInputDialog,
  displayConfirmDialog,
  displayCompletedDialog,
  areaDeliveryIdResistDialog,
  completeFlg,
  timeFormRef,
  groupFormRef,
  chainSelectValues,
  shopSelectValues,
  areaSelectValues,
  areaEditSelectValues,
  areaListItems,
  newAreaListItems,
  shopListItems,
  deliveryGroupListItems,
  deliveryGroupSelectValues,
  bufDeliveryGroupSelectValues,
  listDataArray,
  listGroupDeliveryIdDataArray,
  mappedListData,
  deliveryTimeCommonInput,
  deliveryTimeDeleteInput,
  deliveryGroupCreateInput,
  deliveryGroupUpdateInput,
  deliveryGroupDeleteInput,
  deliveryTimeGetInput,
  deliveryTimeListInput,
  deliveryTimeAllListInput,
  deliveryGroupListInput,
  deliveryGroupGetInput,
  deliverySelectValues,
  displayDaysSettingValues,
  selectTimeCapSelectValues,
  selectGroupCapSelectValues,
  selectTypeSelectValues,
  selectListCheckbox,
  listDeliveryTimeAll,
  listDataAreaDeliveryIdResistArray,
  listGroupDeliveryId,
  areaDeliveryCurrentPage,
  areaDeliveryTotalCount,
  isLoadingAreaDelivery,
  queryDeliverytime,
  onChangeShop,
  onChangeArea,
  onChangeGroup,
  syncTimeFormValues,
  syncGroupFormValues,
  createDeliveryTime,
  createDeliveryGroup,
  chkDeliveryId,
  chkDeliveryIdType,
  chkGroupDeliveryId,
  getDelivery,
  getAreaName,
  getShopName,
  getDeliveryIdName,
  use_list,
  wordList,
});

// 初期化（onMountedフックを設定するため最後に呼び出す）
const { chainViewFlag } = useDeliverySettingInit({
  errdialog,
  errMessage,
  chainListItems,
  chainSelectValues,
  shopSelectValues,
  shopListItems,
  areaListItems,
  shopListInput,
  deliveryTimeListInput,
  deliveryTimeCommonInput,
  deliveryTimeDeleteInput,
  deliveryTimeGetInput,
  wordList,
});
</script>

<style scoped>
/* 対象エリア・便の選択テーブル: チェックボックスの縦中央揃え */
.area-delivery-table :deep(td .v-checkbox) {
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 対象エリア・便の選択テーブルのレイアウト修正 */
.area-delivery-table :deep(table) {
  table-layout: fixed;
  width: 100%;
}
.area-delivery-table :deep(th:nth-child(1)),
.area-delivery-table :deep(td:nth-child(1)) {
  width: 80px;
}
.area-delivery-table :deep(th:nth-child(2)),
.area-delivery-table :deep(td:nth-child(2)) {
  width: 120px;
}
.area-delivery-table :deep(th:nth-child(3)),
.area-delivery-table :deep(td:nth-child(3)) {
  width: 60px;
}
.area-delivery-table :deep(th:nth-child(4)),
.area-delivery-table :deep(td:nth-child(4)) {
  width: 100px;
}
.area-delivery-table :deep(th:nth-child(5)),
.area-delivery-table :deep(td:nth-child(5)) {
  width: 60px;
}
</style>
